import { useSearchParams } from 'react-router-dom'
import { CheckCircle2, CircleAlert } from 'lucide-react'

import { extractAadstsCode } from '@/lib/mailboxes'

/**
 * SOLY-SUPPLIER-002 MS-05 — where Microsoft sends an ADMINISTRATOR back after the consent page
 * (/microsoft/autorisation). Public: the administrator is often not a Soly user (an IT contractor).
 * Anyone can open this address with any parameters, so it believes nothing it cannot check: it writes
 * nothing, connects nothing, and an error wins over « admin_consent=True ». Kept out of the trackers
 * (App.tsx) and out of PublicRoute, which would redirect a signed-in person.
 */
export default function MicrosoftAdminConsentPage() {
  const [params] = useSearchParams()
  const error = params.get('error')
  const granted = !error && params.get('admin_consent')?.toLowerCase() === 'true'
  const code = error ? extractAadstsCode(params.get('error_description')) : null

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md space-y-3 rounded-lg border p-6 text-sm" data-testid="admin-consent-return">
        {error ? (
          <>
            <h1 className="flex items-center gap-2 text-lg font-semibold">
              <CircleAlert className="h-5 w-5 text-destructive" aria-hidden />
              L’autorisation n’a pas été accordée
            </h1>
            <p>Vous pouvez rouvrir le lien reçu pour réessayer.</p>
            {code && (
              <p className="select-all text-xs text-muted-foreground" data-testid="admin-consent-return-code">
                Code Microsoft : {code}
              </p>
            )}
          </>
        ) : granted ? (
          <>
            <h1 className="flex items-center gap-2 text-lg font-semibold">
              <CheckCircle2 className="h-5 w-5 text-green-600" aria-hidden />
              C’est fait
            </h1>
            <p>
              Microsoft indique que l’autorisation a été accordée. Prévenez votre collègue : il peut réessayer de connecter sa boîte
              dans Soly.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-lg font-semibold">Soly</h1>
            <p>Cette page reçoit la réponse de Microsoft quand un administrateur autorise Soly à lire les boîtes mail de son entreprise.</p>
          </>
        )}
      </div>
    </div>
  )
}
